/* Randomize array in-place using Durstenfeld shuffle algorithm */
function shuffleArray (array: unknown[]): void {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
}

export { shuffleArray }
